import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { api } from '../../services/api';
import Loading from '../Loading';
import HeaderPublic from '../../views/eventos/evento/evento-public/HeaderPublic';
import { ContentDesktop } from '../../views/eventos/evento/evento-public/contenido/desktop/ContentDesktop';
import ContentMobile from '../../views/eventos/evento/evento-public/contenido/mobile/ContentMobile';
import { Alert, Box, Button, Tabs, Tab } from '@mui/material';
import { CloseOutlined, ComputerOutlined, PhoneIphoneOutlined, ShoppingCartOutlined } from '@mui/icons-material';
import { DeviceFrame } from "../DeviceFrame";
import { DrawerPreviewMobile } from './DrawerPreviewMobile';
import { DrawerPreviewDesktop } from './DrawerPreviewDesktop';

export const EventoPreview = () => {
  const { id: eventoId } = useParams();
  const history = useHistory();
  const deviceFrameRef = useRef(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [vista, setVista] = useState('desktop');
  const [cantidad, setCantidad] = useState({});
  const [asientosSeleccionados, setAsientosSeleccionados] = useState({});

  //tarifas predeterminadas para mostrar en la vista preview
  const [tarifasPrueba] = useState([
    {
      id: 'preview-tarifa-1',
      concepto: 'Entrada General',
      precio: 10000,
      descripcion: "Tarifa de prueba para la vista Preview",
      idtipo: 1,
      inicio_venta: new Date().toISOString(),
      fin_venta: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      restantes: 100,
      ubicacion: {
        ubicacion: 'Platea',
        tipo_ubicacion: 1
      }
    },
    {
      id: 'preview-tarifa-2',
      concepto: 'VIP',
      precio: 25000,
      descripcion: "Tarifa VIP de prueba",
      idtipo: 1,
      inicio_venta: new Date().toISOString(),
      fin_venta: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      restantes: 50,
      ubicacion: {
        ubicacion: 'Palco VIP',
        tipo_ubicacion: 1
      }
    },
    {
      id: 'preview-voucher-1',
      concepto: 'Consumición Básica',
      precio: 5000,
      descripcion: "Consumición de prueba",
      idtipo: 2,
      inicio_venta: new Date().toISOString(),
      fin_venta: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
      restantes: 200,
    }
  ]);

  const [tarifasSeleccionadas, setTarifasSeleccionadas] = useState([]);

  useEffect(() => {
    const initialCantidad = {};
    tarifasPrueba.forEach(tarifa => {
      initialCantidad[tarifa.id] = 0;
    });
    setCantidad(initialCantidad);
  }, [tarifasPrueba]);

  useEffect(() => {
    if (openDrawer && deviceFrameRef.current) {
      deviceFrameRef.current.scrollTop = 0;
    }
  }, [openDrawer]);

  const callApi = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.eventos.getPreview(eventoId);

      if (response.status === "success") {
        setData(response.data);
      } else {
        setError("No se pudo cargar la vista previa");
      }
    } catch (error) {
      console.error("Error cargando vista previa:", error);
      setError(error.response?.data?.message || "Error al cargar la vista previa");
    } finally {
      setLoading(false);
    }
  }, [eventoId]);

  useEffect(() => {
    callApi();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [callApi]);

  const handleClose = () => {
    window.close();
    setTimeout(() => {
      history.push('/eventos');
    }, 200);
  };

  if (loading) {
    return <Loading />;
  }

  if (error || !data) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error || "No se pudo cargar la vista previa"}
        </Alert>
        <Button
          variant="contained"
          startIcon={<CloseOutlined />}
          onClick={handleClose}
        >
          Cerrar
        </Button>
      </Box>
    );
  }

  const hoy = new Date();

  const tarifasTicketsFiltrados = tarifasPrueba.filter((tarifa) => {
    const inicioVenta = new Date(tarifa.inicio_venta);
    const finVenta = new Date(tarifa.fin_venta);

    return (
      tarifa.idtipo === 1 &&
      inicioVenta <= hoy &&
      hoy <= finVenta
    );
  });

  const tarifasVouchersFiltrados = tarifasPrueba.filter((tarifa) => {
    const inicioVenta = new Date(tarifa.inicio_venta);
    const finVenta = new Date(tarifa.fin_venta);

    return (
      tarifa.idtipo === 2 &&
      inicioVenta <= hoy &&
      hoy <= finVenta
    );
  });

  const toggleDrawer = (newOpenDrawer) => () => {
    setOpenDrawer(newOpenDrawer);
  };

  // Crear evento solo con tarifas de prueba
  const eventoConTarifaPrueba = {
    ...data.evento,
    tarifas: tarifasPrueba
  };

  const tarifasSeleccionadasArray = tarifasPrueba
    .filter(tarifa => (cantidad[tarifa.id] || 0) > 0)
    .map(tarifa => ({
      ...tarifa,
      cantidad: cantidad[tarifa.id] || 0,
    }));

  return (
    <>
      <Box sx={{
        position: 'sticky',
        top: '72px',
        zIndex: 1100,
        backgroundColor: '#5656ff',
        color: 'white',
        px: 4,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}>
        <Box sx={{ flex: 1, minWidth: 180, fontWeight: 'bold', textAlign: 'left' }}>
          VISTA PREVIA DEL EVENTO
        </Box>

        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <Tabs
            value={vista}
            onChange={(_, value) => setVista(value)}
            textColor="inherit"
            indicatorColor="secondary"
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              minHeight: 36,
              height: 36,
              px: 1,
              py: 0.5,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              "& .MuiTabs-indicator": {
                backgroundColor: "transparent",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                color: "#5656ff",
                minHeight: 32,
                minWidth: 90,
                borderRadius: "8px",
                transition: "all 0.3s",
                mx: 0.5,
                fontSize: 16,
                backgroundColor: "transparent",
              },
              "& .Mui-selected": {
                color: "#221a60 !important",
                backgroundColor: "#f4f4f5",
                fontWeight: 700,
              },
            }}
          >
            <Tab icon={<ComputerOutlined />} title="Vista de computadora" value="desktop" sx={{ minHeight: 32, height: 32, color: 'white' }} />
            <Tab icon={<PhoneIphoneOutlined />} title="Vista de celular" value="mobile" sx={{ minHeight: 32, height: 32, color: 'white' }} />
          </Tabs>
        </Box>

        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', minWidth: 120 }}>
          <Button
            variant="contained"
            color="inherit"
            startIcon={<CloseOutlined />}
            onClick={handleClose}
            sx={{ color: '#5656ff', bgcolor: 'white', '&:hover': { bgcolor: '#f0f0f0' } }}
          >
            Cerrar
          </Button>
        </Box>
      </Box>
      <DeviceFrame mode={vista}>
        <div ref={deviceFrameRef} style={{ width: '100%', position: 'relative', overflow: openDrawer ? 'hidden' : 'auto', }}>
          <HeaderPublic data={data.evento} isMobile={vista === 'mobile'} />
          {vista === 'mobile' ? (
            <>
              <Box sx={{ margin: '0 auto', border: '1px solid #eee', borderRadius: 2, boxShadow: 2 }}>
                <ContentMobile data={eventoConTarifaPrueba} isPreview={true} />
                <div className="p-4 rounded-top container-btn-compra" style={{ backgroundColor: "#EBEBEB" }}>
                  <Button
                    id="btn-compra"
                    onClick={toggleDrawer(true)}
                    className="p-4 d-flex gap-1 rounded"
                    aria-label="ver-tarifas"
                  >
                    <ShoppingCartOutlined /> Comenzar compra
                  </Button>
                </div>
              </Box>
              <DrawerPreviewMobile
                open={openDrawer}
                onClose={toggleDrawer(false)}
                tarifas={eventoConTarifaPrueba.tarifas}
                cantidad={cantidad}
                setCantidad={setCantidad}
                tarifasSeleccionadas={tarifasSeleccionadasArray}
                setTarifasSeleccionadas={setTarifasSeleccionadas}
              />
            </>
          ) : (
            <ContentDesktop
              data={eventoConTarifaPrueba}
              cantidad={cantidad}
              toggleDrawer={toggleDrawer}
              setCantidad={setCantidad}
              tarifasTicketsFiltrados={tarifasTicketsFiltrados}
              tarifasVouchersFiltrados={tarifasVouchersFiltrados}
              setTarifasSeleccionadas={setTarifasSeleccionadas}
              asientosSeleccionados={asientosSeleccionados}
              setAsientosSeleccionados={setAsientosSeleccionados}
              isPreview={true}
            />
          )}

          {(tarifasTicketsFiltrados?.length > 0 || tarifasVouchersFiltrados?.length > 0) && (
            <>
              {vista === 'desktop' && (
                <DrawerPreviewDesktop
                  open={openDrawer}
                  onClose={toggleDrawer(false)}
                  tarifasSeleccionadas={tarifasSeleccionadasArray}
                  cantidad={cantidad}
                  handleVolver={toggleDrawer(false)}
                />
              )}
            </>
          )}
        </div>

      </DeviceFrame>
    </>
  );
};